import type { GetLayoutTypes } from './types';
import { getLayoutPreviewImage } from './utils';

import { cn } from '@/lib/utils';

interface LayoutTemplateSelectorProps {
  data: GetLayoutTypes;
  onValueChange: (value: string) => void;
  value: string;
}

const LayoutTemplateSelector = ({
  data,
  onValueChange,
  value
}: LayoutTemplateSelectorProps) => {
  return (
    <div>
      <p className="mb-1 text-sm font-medium">Layout template</p>
      <hr className="border-border mb-4" />
      <div className="flex gap-4 overflow-x-auto pb-2">
        {data.layoutTypes.map(layoutType => {
          const previewSrc = getLayoutPreviewImage(layoutType.value);
          const isSelected = value === layoutType.value;

          return (
            <button
              className={cn(
                'border-border flex w-[200px] shrink-0 cursor-pointer flex-col rounded-md border p-4',
                isSelected && 'border-primary ring-primary ring-1'
              )}
              key={layoutType.value}
              onClick={() => onValueChange(layoutType.value)}
              type="button"
            >
              <label className="mb-3 flex cursor-pointer items-center gap-2">
                <span
                  className={cn(
                    'flex size-4 shrink-0 items-center justify-center rounded-full border',
                    isSelected
                      ? 'border-primary bg-primary'
                      : 'border-muted-foreground'
                  )}
                >
                  {isSelected && (
                    <span className="bg-primary-foreground size-1.5 rounded-full" />
                  )}
                </span>
                <span className="text-sm">{layoutType.name}</span>
              </label>
              {previewSrc ? (
                <img
                  alt={`${layoutType.name} layout preview`}
                  className="h-auto w-full rounded"
                  src={previewSrc}
                />
              ) : (
                <div className="bg-muted flex aspect-video w-full items-center justify-center rounded">
                  <span className="text-muted-foreground text-xs">
                    No preview
                  </span>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LayoutTemplateSelector;
